import { Text } from "@redotech/redo-web/text";
import { memo, ReactNode } from "react";

export interface ConversationTicketFieldTitleProps {
  children: ReactNode;
}

export const ConversationTicketFieldTitle = memo(
  function ConversationTicketFieldTitle({
    children,
  }: ConversationTicketFieldTitleProps) {
    return (
      <Text fontSize="xs" textColor="quaternary" whiteSpace="nowrap">
        {children}
      </Text>
    );
  },
);
